module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAArElEQVQoU2NkYGBgkNcp0GRl/fvmzvnJr0F8ZMAIkmRi/nuA4T/jK2bm/07oihglDHNFOf8y7mNgZNBh+M9wBV0RI8g4FcNc0b84FIEV4FMEV4BLEYoCBgYGRgX9vDmMDAxJ/xkYvv39/98DWQFIchojA0MGSPLffwa/R5cm7YUpwCoJshakAKckWIGibr7df8b/+xkYGX7AjEUJSRBHUTc39S8j4z2QnehBDQBQf2TZGZQL3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back_right.png
// module id = N/G/
// module chunks = 167